module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-stone-path-remnants.eb3c0323.png";